import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import eventoService from '../services/eventoService';
import '../style/components/PushNotification.css';

const PushNotification = ({ notificacion, onClose, onViewDetail }) => {
    const [isClosing, setIsClosing] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Auto-close después de 5 segundos
        const timer = setTimeout(() => {
            handleClose();
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            onClose();
        }, 300); // Tiempo de animación
    };

    const handleClick = async () => {
        if (notificacion.idEvento) {
            try {
                const resEvento = await eventoService.getEventoById(notificacion.idEvento);
                const evento = resEvento.data;

                const rutaTramite = evento?.rutaTramite || (evento?.idTramite ? `/tramites/${evento.idTramite}` : null);
                if (rutaTramite) {
                    navigate(rutaTramite);
                    handleClose();
                } else {
                    // Si no → mostrar detalle
                    onViewDetail(evento);
                    handleClose();
                }
            } catch (err) {
                console.error('Error al obtener evento:', err);
            }
        }
    };

    return (
        <div 
            className={`push-notification ${isClosing ? 'closing' : ''}`}
            onClick={handleClick}
        >
            <div className="push-notification-content">
                <div className="push-notification-icon">🔔</div>
                <div className="push-notification-text">
                    <div className="push-notification-title">{notificacion.mensaje || 'Nueva notificación'}</div>
                    <div className="push-notification-time">
                        {notificacion.fechaProgramada 
                            ? new Date(notificacion.fechaProgramada).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit'
                            })
                            : 'Ahora'}
                    </div>
                </div>
                <button 
                    className="push-notification-close"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleClose();
                    }}
                >
                    ×
                </button>
            </div>
        </div>
    );
};

export default PushNotification;
